module.exports = __webpack_public_path__ + "img/DiNapoli-3.cd06eab7.jpg";